import { Component, OnInit, Input } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';


@Component({
    standalone: true,
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.css'],
    imports: [MatProgressSpinner]
})
export class LoadingComponent implements OnInit {
  @Input() message;
  constructor() { }

  ngOnInit() {
  }

}
